import { Co2MaterialType } from "@api/apiClient";
import { makeAutoObservable } from "mobx";

// Add to the global window object for auto-completion in the console
// > window.JobStatusStore
export { };
declare global {
  interface Window {
    CompareMaterialsStore: CompareMaterialsStore;
  }
}

export class Totals {
  total: number = 0;
  co2eTotal: number = 0;
}

export class ElementMetrics {
  length: Totals = new Totals();
  area: Totals = new Totals();
  volume: Totals = new Totals();
  quantity: Totals = new Totals();
  co2eTotal: number = 0;
}

class CompareMaterialsStore {
  public elementMetrics: ElementMetrics = new ElementMetrics();
  public co2MaterialTypes: Co2MaterialType[] = [];

  constructor() {
    window.CompareMaterialsStore = this;
    makeAutoObservable(this, {}, { autoBind: true });
  }

  clear = () => {
    this.co2MaterialTypes = [];
    this.elementMetrics = new ElementMetrics();
  };

  toggleCo2MaterialType = (co2MaterialType: Co2MaterialType) => {
    const index = this.co2MaterialTypes.findIndex((m) => {
      if (m.co2MaterialTypeId) {
        return m.co2MaterialTypeId === co2MaterialType.co2MaterialTypeId;
      }
      if (m.externalId) {
        return m.externalId === co2MaterialType.externalId;
      }
      return false;
    });
    if (index === -1) {
      this.co2MaterialTypes.push(co2MaterialType);
    } else {
      this.co2MaterialTypes.splice(index, 1);
    }
    this.co2MaterialTypes = [...this.co2MaterialTypes];
    console.log("CompareMaterialsStore: ", this.co2MaterialTypes);
  };

  removeCo2MaterialLibrary = (co2MaterialLibraryId: string) => {
    this.co2MaterialTypes = this.co2MaterialTypes.filter((m) => m.co2MaterialLibraryId !== co2MaterialLibraryId);
    console.log("CompareMaterialsStore: ", this.co2MaterialTypes);
  };

  setElementMetrics = (elementMetrics: ElementMetrics) => {
    this.elementMetrics = elementMetrics;
  };
}

export default CompareMaterialsStore;